<script>
    export let totalCards = 0;
    export let reviewedCards = [];
    export let onBack = () => {};
    export let onReset = () => {};
</script>

<div class="results">
    <h2 class="text-primary">Session terminée!</h2>
    <p class="text-base-content/70">
        Vous avez révisé {totalCards} carte{totalCards > 1 ? "s" : ""}.
    </p>

    <div class="results-summary">
        <div class="result-item easy bg-success/10 border-success">
            <span class="result-label text-base-content/70">Facile</span>
            <span class="result-count text-success"
                >{reviewedCards.filter((r) => r === 1).length}</span
            >
        </div>
        <div class="result-item medium bg-warning/10 border-warning">
            <span class="result-label text-base-content/70">Moyen</span>
            <span class="result-count text-warning"
                >{reviewedCards.filter((r) => r === 2).length}</span
            >
        </div>
        <div class="result-item hard bg-error/10 border-error">
            <span class="result-label text-base-content/70">Difficile</span>
            <span class="result-count text-error"
                >{reviewedCards.filter((r) => r === 3).length}</span
            >
        </div>
    </div>

    <div class="results-actions">
        <button class="primary-btn btn btn-primary" on:click={onReset}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <polyline points="23 4 23 10 17 10"></polyline>
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>
            </svg>
            Réinitialiser les révisions
        </button>
        <button class="secondary-btn btn btn-outline btn-primary" on:click={onBack}
            >Retour</button
        >
    </div>
</div>

<style>
    .results {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2rem;
        padding: 2rem;
        min-height: 60vh;
        justify-content: center;
    }

    .results h2 {
        margin: 0;
        font-size: 2.5rem;
    }

    .results > p {
        font-size: 1.2rem;
        margin: 0;
    }

    .results-summary {
        display: flex;
        gap: 2rem;
        margin: 1rem 0;
    }

    .result-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.5rem;
        padding: 1.5rem;
        border-radius: 12px;
        min-width: 120px;
    }

    .result-item.easy {
        border: 2px solid;
    }

    .result-item.medium {
        border: 2px solid;
    }

    .result-item.hard {
        border: 2px solid;
    }

    .result-label {
        font-size: 0.9rem;
        font-weight: 600;
        text-transform: uppercase;
    }

    .result-count {
        font-size: 2.5rem;
        font-weight: 700;
    }

    .results-actions {
        display: flex;
        gap: 1rem;
    }

    .primary-btn,
    .secondary-btn {
        padding: 0.8rem 1.5rem;
        border-radius: 8px;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
    }

    .primary-btn {
        border: none;
        display: flex;
        align-items: center;
        gap: 0.5rem;
    }

    .primary-btn:hover {
    }

    .secondary-btn {
        border: 2px solid;
    }

    .secondary-btn:hover {
    }

    @media (max-width: 640px) {
        .results-summary {
            flex-direction: column;
            gap: 1rem;
        }

        .results-actions {
            flex-direction: column;
            width: 100%;
        }

        .results-actions button {
            width: 100%;
        }
    }
</style>
